<template>
  <div class="wl-container">
    <el-row style="height: 100%;">
      <el-col :span="4" style="height: 100%;">
        <div class="pbc-list">
          <p class="title">
            {{$t('ROUTRE_META_1')}} - {{audit=='1'?$t('COMMON_INTERIM'):$t('COMMON_FINAL')}}
          </p>
          <div v-if="editView=='Y'" class="add-pbc" @click="addNewPbc">
            <i class="el-icon-plus" style="margin-right: 5px;"></i>
            {{ $t('btn_add') }}
          </div>
          <el-form :model="ruleForm"
                         :rules="rules"
                         ref="ruleForm"
                         size="large"
                         label-position="top"
                         class="pbc-ruleForm">
          <div class="ul" ref="scrollWrapRef">
            <li v-for="(i, index) in pbcList" :key="i.groupId" @click="activePbc(i)" :class="activeId == i.groupId ? 'item active' : 'item'">
              <span class="name" :title="i.groupName" style="font-size: 12px">{{i.groupName}}</span>
              <i v-if="editView=='Y'" @click.stop="deletePbc(i)" class="el-icon-delete"></i>
              <template v-if="activeId == i.groupId">
                <div v-loading="topicLoading" style="padding: 0 12px">
                    <el-form-item :label="$t('PAGE_PBC_LIST_NAME')" prop="listName">
                      <el-input v-model="ruleForm.listName" maxlength="100" @input="handleChangeTimesCount"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('TABLE_HEADER_periodEndDate')" prop="endDate">
                      <el-date-picker v-model="ruleForm.endDate" type="date" @change="onPeriendDateChange" style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                </div>
              </template>
            </li>
          </div>
        </el-form>
        </div>
      </el-col>
      <el-col :span="20" class="pl-12" style="height: 100%;">
        <div class="__right-box">
          <div class="__right-title">
            <p class="title">
              {{$t('PAGE_PBC_LIST_DETAILED')}}
            </p>
            <div style="display: flex;">
                <el-button class="cancel-btn right"
                          @click="onCancel">{{$t('comment_reSet')}}
                </el-button>
                <el-button @click="SavePbcConfim"
                          style="float: right"
                          size="small"
                          :loading="saveLoading"
                          class="wl-green">{{$t('btn_save')}}
                </el-button>
            </div>
          </div>
          <div v-if="pbcList.length > 0" class="__right-content">
            <el-row>
              <el-col :span="6">
                <div class="__title">
                  <span>1</span>
                  {{ $t('step_1') }}
                </div>
                <div class="tree-box">
                  <div class="filter-text-input">
                    <el-input v-model="filterText" :placeholder="$t('ENTER_SEARCH_CONTENT')" />
                  </div>
                  <div class="tree-inner">
                    <el-tree :default-expand-all="true"
                            :expand-on-click-node="false"
                            :data="treeData"
                            :props="defaultProps"
                            :check-strictly="true"
                            :default-checked-keys="entityTreeCheckedList"
                            :filter-node-method="filterNode"
                            node-key="id"
                            show-checkbox
                            @check="handleCheckChange"
                            ref="tree">
                      <div slot-scope="{ node, data }" class="entity-list-tree-node">
                        <span :title="node.label">{{ node.label }}</span>
                        <span class="extra-area" v-if="data.childEntity.length > 0">
                            <a @click="clickAll(data, !node.checked)">{{node.checked ? $t('unselect_all') : $t('select_all')}}</a>
                            <!-- <a v-else @click="clickAll(data, !node.checked)"></a> -->
                        </span>
                      </div>
                    </el-tree>
                  </div>
                </div>
              </el-col>
              <el-col :span="18" class="pl-12">
                <div class="__title">
                  <span>2</span>
                  {{ $t('step_2') }}
                </div>
                <div class="col-inner">
                  <div class="table-box">
                    <div style="height: 15px; font-weight: bold">
                      {{$t('standardAccounts')}}
                    </div>
                    <div class="table-inner" style="height: calc(100% - 15px)">
                      <div class="topic-table">
                          <el-tabs v-model="topicType" @tab-click="handleTopicClick" style="height: 40px;">
                            <el-tab-pane :label="$t('TOPIC_TYPE._1')" name="1" :disabled="topicDisabled || topicDisabled2" />
                            <el-tab-pane :label="$t('TOPIC_TYPE._2')" name="2" :disabled="topicDisabled || topicDisabled2" />
                            <el-tab-pane :label="$t('TOPIC_TYPE._3')" name="3" :disabled="topicDisabled || topicDisabled2" />
                            <el-tab-pane :label="$t('TOPIC_TYPE._4')" name="4" :disabled="topicDisabled || topicDisabled2" />
                            <el-tab-pane :label="$t('TOPIC_TYPE._5')" name="5" :disabled="topicDisabled || topicDisabled2" />
                            <el-tab-pane :label="$t('TOPIC_TYPE._6')" name="6" :disabled="topicDisabled || topicDisabled2" />
                            <el-tab-pane :label="$t('TOPIC_TYPE._7')" name="7" :disabled="topicDisabled || topicDisabled2" />
                          </el-tabs>
                          <el-table :data="standardTableData"
                                    row-key="topicId"
                                    border
                                    ref="topicTable"
                                    stripe
                                    :indent="10"
                                    height="calc(100% - 80px)"
                                    v-loading="topicLoading"
                                    highlight-current-row
                                    :tree-props="defaultTableProps"
                                    :default-expand-all="expand"
                                    class="wl-table">
                            <el-table-column width="120">
                              <template slot-scope="scope">
                                <el-checkbox v-if="scope.row.childTopic.length<=0"
                                            v-model="scope.row.checked" @change="handleCheckboxChange"></el-checkbox>
                                <a v-else class="topic-select-all" @click="clickAllTopicFilter(scope.row)">{{topicFilter(scope.row)}}</a>
                              </template>
                              <template slot="header" slot-scope="scope">
                                <i v-if="!expand" @click="expandAll" class="fa fa-angle-double-right openAll"
                                  aria-hidden="true"></i>
                                <i v-if="expand" @click="expandAll" class="fa fa-angle-double-down openAll"
                                  aria-hidden="true"></i>
                              </template>
                            </el-table-column>
                            <el-table-column
                                  prop="topicName"
                                  show-overflow-tooltip
                                  :label="$t('PAGE_PBC_LIST_TOPIC')">
                            </el-table-column>
                            <el-table-column
                              prop="topicDesc"
                              min-width="160"
                              show-overflow-tooltip
                              :label="$t('PAFE_PBC_LIST_DESC')"
                            >
                            </el-table-column>
                            <!-- <el-table-column :label="$t('TABLE_HEADER_Action')"
                                            align="center"
                                            width="100">
                              <template slot-scope="scope">
                                <i v-if="editView=='Y'&&(scope.row.childTopic==null||scope.row.childTopic.length<=0)&&scope.row.topicSrc=='2'"
                                  class="el-icon-delete wl-icon-delete"
                                  @click="deleteTopic(scope.row,scope.$index)"></i>
                                <i v-if="scope.row.topicId && scope.row.topicId!= '' && editView=='Y'&&(scope.row.childTopic==null||scope.row.childTopic.length<=0)&&scope.row.topicSrc=='2'"
                                  class="el-icon-setting icon-set-cls"
                                  @click="reverseAuth(scope.row)"
                                />
                                <i v-if="scope.row.topicId && scope.row.topicId!= '' && editView=='Y'&&(scope.row.childTopic==null||scope.row.childTopic.length<=0)&&scope.row.topicSrc=='2'"
                                  class="el-icon-edit icon-set-cls"
                                  @click="openEdit(scope.row)" />
                              </template>
                            </el-table-column> -->
                          </el-table>
                          <el-pagination class="wl-pagination"
                                        style="height: 40px;"
                                        :current-page="pagination.pageNum"
                                        :page-size="pagination.pageSize"
                                        @size-change="onSizeChange"
                                        @current-change="onCurrentPageChange"
                                        :page-sizes="[10, 50, 100]"
                                        layout="prev, pager, next, sizes, total"
                                        :total="pagination.total"></el-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="custom-account">
                  <div class="custom-title">
                    <span>
                      {{$t('PAGE_PBC_LIST_TOPIC_CUS')}}
                    </span>
                    <div>
                      <el-button v-if="editView=='Y'" @click="addTopic"
                          style="float: right"
                          size="small"
                          plain>
                          {{ $t('btn_add_1') }}
                      </el-button>
                      <el-button size="small" plain class="import-entity-btn" @click="toggleAccountVisible">
                        {{ $t('batchImport') }}
                      </el-button>
                    </div>
                  </div>
                  <el-table :data="tableCustomData"
                              row-key="topicId"
                              border
                              stripe
                              :indent="10"
                              height="calc(100% - 35px)"
                              v-loading="topicLoading"
                              highlight-current-row
                              :tree-props="defaultTableProps"
                              :default-expand-all="expand"
                              class="wl-table">
                      <el-table-column width="90" align="center">
                        <template #header>
                          <a class="topic-select-all" @click="clickAllCustomTopic()">
                            {{ topicFilter({ childTopic: tableCustomData }) }}
                          </a>
                        </template>
                        <template slot-scope="scope">
                          <el-checkbox
                            v-if="scope.row.childTopic.length <= 0"
                            v-model="scope.row.checked"
                            @change="handleCheckboxChange">
                          </el-checkbox>
                        </template>
                      </el-table-column>
                      <el-table-column
                            prop="topicName"
                            show-overflow-tooltip
                            :label="$t('PAGE_PBC_LIST_TOPIC')">
                      </el-table-column>
                      <el-table-column
                        prop="topicDesc"
                        show-overflow-tooltip
                        :label="$t('PAFE_PBC_LIST_DESC')">
                      </el-table-column>
                      <el-table-column :label="$t('TABLE_HEADER_Action')"
                                      align="center"
                                      width="100">
                        <template slot-scope="scope">
                          <i v-if="editView=='Y'&&(scope.row.childTopic==null||scope.row.childTopic.length<=0)&&scope.row.topicSrc=='2'"
                            class="el-icon-delete wl-icon-delete"
                            @click="deleteTopic(scope.row,scope.$index)"></i>
                          <!-- <i v-if="scope.row.topicId && scope.row.topicId!= '' && editView=='Y'&&(scope.row.childTopic==null||scope.row.childTopic.length<=0)&&scope.row.topicSrc=='2'"
                            class="el-icon-setting icon-set-cls"
                            @click="reverseAuth(scope.row)"
                          /> -->
                          <i v-if="scope.row.topicId && scope.row.topicId!= '' && editView=='Y'&&(scope.row.childTopic==null||scope.row.childTopic.length<=0)&&scope.row.topicSrc=='2'"
                            class="el-icon-edit icon-set-cls"
                            @click="openEdit(scope.row)" />
                        </template>
                      </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <accounts-add v-if="addVisible"
               :initData="editRow"
               :onAdd="addTopicToList"
                :onEdit="editTopic"
               :onCancel="cancel"/>

    <import-account :visible="accountVisible" :groupId="activeId" @on-upload-success="uploadAccountSuccess" @onDialogClose="accountVisible = false"/>
  </div>
</template>
<script>
    import {deleteConfirm, dateFormat, UserInput} from '@/utils'
    import API from '@/api'
    import AccountsAdd from './accounts-add'
    import {mapGetters} from 'vuex'
    import importAccount from './import-account'

    export default {
        data() {
            return {
                editView: 'Y',
                editPicker: '',
                siteId: '',
                audit: '',
                dateStamp: 0,
                treeData: [],
                defaultProps: {
                    children: 'childEntity',
                    label: 'entityName'
                },
                entityTreeCheckedList: [],
                activeId: '1',
                pbcList: [],
                ruleForm: {
                    listName: '',
                    endDate: '',
                    RequestInfo: ''
                },
                defaultTableProps: {
                    children: 'childTopic',
                    hasChildren: 'hasChildren'
                },
                topicLoading: false,
                topicData: [],
                tableData: [],
                kpmgOwnerList: [],
                clientOwnerList: [],
                addVisible: false,
                newPbcTreeData: [],
                newPbcTopicData: [],
                chooseTopicList: [],
                tableCheckedList: [],
                editFlag: false,
                pagination: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                saveLoading: false,
                expand: false,
                accountVisible: false,
                editRow: {},
                topicType: '1',
                topicTreeData: [],
                topicDisabled: false,
                topicDisabled2: false,
                filterText: '',
                filterNodeList: [],
                // 页面所有模块数据变化次数，用以判断是否可以直接切换，当此数大于0表示有更改未保存
                changeTimesCount: 0,
            };
        },
        filters: {
            formatDate: value => {
                if (value != null) {
                    return dateFormat(new Date(value));
                } else {
                    return value;
                }
            },
        },
        computed: {
            ...mapGetters('common', {
                getSite: 'getSite'
            }),
            rules() {
                const rules = {
                    listName: [
                        {required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'},
                        {
                            pattern: UserInput.reg,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_01')
                        }
                    ],
                    endDate: [{required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur'}],
                    RequestInfo: [
                        {
                            pattern: UserInput.reg1,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_02')
                        }
                    ]
                }
                return rules
            },
            getOption() {
              return {
                disabledDate: (time) => {
                  return time.getTime() > this.dateStamp;
                },
              }
            },
            // 自定义的会计科目表格数据
            tableCustomData() {
              const _allArray = []
              this.tableData.forEach((item, index) => {
                _allArray.push(...item)
              })
              const cuntomArr = _allArray.filter(item => item.topicSrc === 2)
              return cuntomArr
            },
            // 会计科目表格数据
            standardTableData() {
              const _allArray = []
              this.tableData.forEach((item, index) => {
                _allArray.push(...item)
              })
              const noCustomData= _allArray.filter(item => item.topicSrc !== 2)
              const tableList = this.cutArray(noCustomData, this.pagination.pageSize)
              return tableList[this.pagination.pageNum - 1]
            }
        },
        watch: {
          tableData: {
            handler: function(val, oldVal){
              // 监听topicList 查询是否选中，如果选中不能切换tab
              if(!this.topicDisabled){
                this.topicDisabled2 = false
                if(val instanceof Array){
                  for(let i = 0 ; i < val.length; i++){
                    if(val[i] instanceof Array){
                      for(let j = 0; j < val[i].length; j++ ){
                        if(val[i][j].checked){
                          this.topicDisabled2 = true
                          break
                        } else {
                          if(val[i][j].childTopic && val[i][j].childTopic.length > 0){
                            if(val[i][j].childTopic.some(item => item.checked)){
                              this.topicDisabled2 = true
                              break
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            },
            deep: true
          },
          filterText(val) {
            this.filterNodeList = []
            this.$refs.tree.filter(val);
          },
        },
        methods: {
          topicFilter(rowData) {
            return rowData.childTopic.some(v => !v.checked) ? this.$t('select_all') : this.$t('unselect_all')
          },
          // entity过滤
          filterNode(value, data) {
            if (!value) return true;
            let isShow = data.entityName.toLowerCase().indexOf(value.toLowerCase()) !== -1
            if(isShow) {
              this.filterNodeList.push(data)
            }
            return isShow;
          },
            handleTopicClick(tab, event){
              let topicTreeTemp = []
              if (this.topicType === '1') {
                topicTreeTemp = this.topicTreeData.filter(item => item.topicType === null || item.topicType === 1)
              } else {
                topicTreeTemp = this.topicTreeData.filter(item => item.topicType == this.topicType)
              }
              this.topicData = topicTreeTemp
              this.tableData = this.cutArray(this.topicData, this.pagination.pageSize)
              this.pagination.total = topicTreeTemp.length - this.tableCustomData.length
              this.pagination.pageNum = 1
            },
            clickAll(data, checked) {
              if(this.filterText.length > 0 ){
                this.fileterClickAll(data, checked)
              } else {
                this.$refs.tree.setChecked(data.id, checked, false);
                data.ckecked = checked
                if (data.childEntity.length > 0) {
                  data.childEntity.forEach(child => this.clickAll(child, checked));
                }
              }
            },
          fileterClickAll(data, checked) {
            let temp = []
            if(data.entityType === 'ROOT') {
              temp.push(data.id)
              this.filterNodeList.forEach(item => {
                temp.push(item.id)
                temp.push(item.parentKey)
              })
              this.iteratorTree(data, checked, temp)
            } else {
              // Entity
              if(!data.disabled){
                this.$refs.tree.setChecked(data.id, checked, false)
                data.checked = checked
              }
              if(data.childEntity.length > 0) {
                for(let i = 0 ; i < data.childEntity.length; i++){
                  if(data.childEntity[i].entityName.indexOf(this.filterText) != -1 && !data.childEntity[i].disabled) {
                    this.$refs.tree.setChecked(data.childEntity[i].id, checked, false)
                    data.childEntity[i].checked = checked
                  }
                }
              }
            }
          },
          // topic click all cancel all
          clickAllTopicFilter(rowData) {
            const isSelectAll = rowData.childTopic.some(v => !v.checked)
            rowData.childTopic.forEach(v => {
              v.checked = isSelectAll
            })
            this.handleChangeTimesCount()
          },
          // custom topic click all cancel all
          clickAllCustomTopic() {
            const isSelectAll = this.tableCustomData.some(v => !v.checked)
            this.tableCustomData.forEach(v => {
              v.checked = isSelectAll
            })
            this.handleChangeTimesCount()
          },
          iteratorTree(data, checked, idList) {
            if((idList.indexOf(data.id) != -1 || idList.indexOf(data.key) != -1) && !data.disabled) {
              this.$refs.tree.setChecked(data.id, checked, false)
              data.checked = checked
            }
            if (data.childEntity.length > 0) {
              data.childEntity.forEach(child => this.iteratorTree(child, checked, idList));
            }
          },
            setCurrent(row) {
              this.$refs.topicTable.setCurrentRow(row);
            },
            expandAll() {
                this.expand = !this.expand
                this.tableData[this.pagination.pageNum - 1].forEach((i, n) => {
                    if (i.childTopic && i.childTopic.length > 0) {
                        this.$refs.topicTable.toggleRowExpansion(i, this.expand)
                    }
                })
            },
            onCurrentPageChange(current) {
                this.expand = false              
                this.pagination.pageNum = current;
            },
            onSizeChange(current){
              this.expand = false
              this.pagination.pageSize = current;
              this.tableData = this.cutArray(this.topicData, this.pagination.pageSize)
            },
            pickerShow(data) {
                this.$refs['date' + data].focus()
            },
            onCancel() {
              this.$router.go(-1)
            },
            getChooseTopicList(data, res = []) {
                data.forEach(i => {
                    if (i.checked === true) {
                        res.push(i);
                    }
                    if (i.childTopic && i.childTopic.length > 0) {
                        this.getChooseTopicList(i.childTopic, res);
                    }
                });
                return res
            },
            findRowItemInfo(topicId) {
              let pageNum = 0
              let fatherRow = null
              const {tableData} = this
              while(pageNum < tableData.length) {
                const thatPageDatas = tableData[pageNum++]
                fatherRow = thatPageDatas.findIndex(item => Array.isArray(item.childTopic) && item.childTopic.some(topic => {
                  return topic.topicId === topicId
                }));
                if (fatherRow != null) break;
              }
              return [pageNum, fatherRow]
            },
            checkParams() {
              return null
            },
            // checkParams(params) {
            // const {groupTopicBindList} = params;
            //   let msg = null
            //   debugger;
            //   if (Array.isArray(groupTopicBindList)) {
            //       groupTopicBindList.some(item => {
            //         debugger;
            //       if (item.checked && !item.dueDay && (item.pid != null || item.type === 'NEW')) {
            //         msg = window.vm.$t("PAGE_PBC_LIST_CEHCK_DUEDATE")
            //         this.chooseTopicList = []
            //         const [pageNum, fatherRow] = this.findRowItemInfo(item.topicId)
            //         this.pagination.pageNum = pageNum
            //         this.$nextTick(() => {
            //           this.$refs.topicTable.toggleRowExpansion(this.tableData[pageNum - 1][fatherRow], true)
            //           this.setCurrent(item)
            //         })
                    
            //         return true
            //       }
            //     })
            //   }
            //   return msg
            // },
            async SavePbc() {
                this.saveLoading = !this.saveLoading
                const params = {
                    siteId: this.siteId,
                    auditType: this.audit,
                    groupName: this.ruleForm.listName,
                    detailedInfoReq: this.ruleForm.RequestInfo,
                    periodEndDateTime: dateFormat(new Date(this.ruleForm.endDate), 'yyyy-MM-dd'),
                    entityIdList: this.$refs.tree.getCheckedKeys(),
                    groupTopicBindList: this.chooseTopicList,
                    topicType: Number(this.topicType)
                };
                const msg = this.checkParams(params)
                if (msg) {
                  this.$message.error(msg)
                  this.saveLoading = !this.saveLoading
                  return
                }
                try {
                    const {data, code} = await API.pbc.addPbcGroup(params);

                    if (code == '1') {
                        this.getPbcList('LAST')
                        this.$message.success(this.$t('msg_success'))
                    } else {
                        this.$message.error(this.$t(code))
                    }
                }
                catch(e) {}
                finally {
                    this.chooseTopicList = []
                    this.saveLoading = !this.saveLoading
                }
            },
            async editPbc() {
                this.saveLoading = !this.saveLoading
                const params = {
                  siteId: this.siteId,
                    groupId: this.activeId,
                    auditType: this.audit,
                    groupName: this.ruleForm.listName,
                    detailedInfoReq: this.ruleForm.RequestInfo,
                    periodEndDateTime: dateFormat(new Date(this.ruleForm.endDate), 'yyyy-MM-dd'),
                    entityIdList: this.$refs.tree.getCheckedKeys(),
                    groupTopicBindList: this.chooseTopicList
                }
                const msg = this.checkParams(params)
                if (msg) {
                  this.$message.error(msg)
                  this.saveLoading = !this.saveLoading
                  return
                }
                try {
                    // 仅判断定制科目的长度 
                    if (params.groupTopicBindList.some(v => v.topicSrc === 2 && v.topicDesc && v.topicDesc.length > 255)) {
                      this.$message.error(this.$t('updatePbcGroup_topicDesc_overlength'))
                      return
                    }
                    const {data, code} = await API.pbc.updatePbcGroup(params)
                    
                    if (code == '1') {
                        this.getPbcList('CURRENT')
                        this.$message.success(this.$t('msg_success'))
                    } else {
                        this.$message.error(this.$t(code))
                    }
                }
                catch(e) {
                  console.error('update pbc group error:', e);
                }
                finally {
                    this.chooseTopicList = []
                    this.saveLoading = !this.saveLoading
                }
            },
            async SavePbcConfim() {
                this.$refs.ruleForm.validate(validate => {
                    if (validate) {
                        this.chooseTopicList = this.getChooseTopicList(this.topicData)
                        if (_.isEmpty(this.chooseTopicList) || _.isEmpty(this.$refs.tree.getCheckedKeys())) {
                            this.$message.error(this.$t('PBC_LIST_ADD_ERR'))
                            return
                        }

                        if (this.editFlag) {
                            this.editPbc()
                        } else {
                            this.SavePbc()
                        }
                    }
                })
            },
            addNewPbc() {
              // 添加时，若已经存在新添加的未保存，直接跳转底部即可
                const newList = this.pbcList.filter(item => item.type && item.type === 'New')
                if (newList.length) {
                  // 滚动到底部
                  this.$refs.scrollWrapRef.scrollTop = this.$refs.scrollWrapRef.scrollHeight;
                  return
                }
                if (this.changeTimesCount > 0) {
                  this.$confirm(this.$t('pbc_change_tips'), this.$t('COMMON_TIP'), {
                      confirmButtonText: this.$t('btn_confirm'),
                      cancelButtonText: this.$t('btn_cancel'),
                      type: 'warning'
                  }).then(() => {
                    this.initPbcDetail('')
                    this.editFlag = false
                    this.activeId = this.pbcList.length + 1 + ''
                    this.topicDisabled = false
                    this.pbcList.push({
                      groupId: (this.pbcList.length + 1) + '',
                      groupName: 'New PBC List',
                      type: 'New'
                    })
                    this.$nextTick(() => {
                      // 滚动到底部
                      this.$refs.scrollWrapRef.scrollTop = this.$refs.scrollWrapRef.scrollHeight;
                    })
                  }).catch(() => {});
                } else {
                  this.initPbcDetail('')
                  this.editFlag = false
                  this.activeId = this.pbcList.length + 1 + ''
                  this.topicDisabled = false
                  this.pbcList.push({
                    groupId: (this.pbcList.length + 1) + '',
                    groupName: 'New PBC List',
                    type: 'New'
                  })
                  this.$nextTick(() => {
                    // 滚动到底部
                    this.$refs.scrollWrapRef.scrollTop = this.$refs.scrollWrapRef.scrollHeight;
                  })
                }
            },
            getEntityTreeDefaultChecked(node) {
                node.forEach((i, n) => {
                    if (i.checked) {
                        this.entityTreeCheckedList.push(i.id)
                    }
                    if (i.childEntity && i.childEntity.length > 0) {
                        this.getEntityTreeDefaultChecked(i.childEntity)
                    }
                })
            },
            initPbcDetail(groupId) {
                this.topicLoading = true
                const params = {
                    siteId: this.siteId,
                    groupId: groupId,
                    lang: this.$i18n.locale
                }
                API.pbc.queryInitPbcDetail(params).then(res => {
                    if (res.code == '1') {
                        this.entityTreeCheckedList = []
                        this.treeData = [res.data.clientTree]
                        this.getEntityTreeDefaultChecked([res.data.clientTree])
                        this.ruleForm.listName = res.data.groupName
                        this.ruleForm.endDate = res.data.periodEndDate
                        this.ruleForm.RequestInfo = res.data.detailedInfoReq
                        // 添加过滤
                        this.topicTreeData = res.data.topicTree
                        this.topicType = res.data.topicType === null ? '1' : res.data.topicType + ''
                        let topicTreeTemp = []
                        if (this.topicType === '1') {
                          topicTreeTemp = res.data.topicTree.filter(item => item.topicType === null || item.topicType === 1)
                        } else {
                          topicTreeTemp = res.data.topicTree.filter(item => item.topicType == this.topicType)
                        }
                        this.topicData = topicTreeTemp
                        this.dateStamp = res.data.periodEndDateStamp
                        this.tableData = this.cutArray(this.topicData, this.pagination.pageSize)
                        this.pagination.total = topicTreeTemp.length - this.tableCustomData.length
                        // 清空计数
                        this.changeTimesCount = 0
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.topicLoading = false
                })
            },
            cutArray(array, subLength) {
                let index = 0;
                let newArr = [];
                while (index < array.length) {
                    newArr.push(array.slice(index, index += subLength));
                }
                return newArr;
            },
            addTopic() {
                this.editRow = {}
                this.addVisible = !this.addVisible
            },
            cancel() {
                this.addVisible = !this.addVisible
            },
            onPeriendDateChange(date) {
              this.dateStamp = date.getTime()
              this.handleChangeTimesCount()
            },
            // 获取pbc列表后默认展示哪一个pbc：
            // type: CURRENT INIT LAST意思分别为：当前的不变、初始化默认的第一个、列表中最后一条pbc
            async getPbcList(type) {
                const params = {
                    siteId: this.siteId,
                    auditType: this.audit
                }
                try {
                    const {data, code} = await API.pbc.queryPbcList(params)

                    if (code == '1') {
                        this.pbcList = data
                        this.getDetailInfoByType(type)
                    } else {
                        this.$message.error(this.$t(code))
                    }
                }
                catch(e) {}
                finally {}
            },
            deleteTopic(row, index) {
                if (row.type && row.type == 'NEW') {
                    this.topicData.splice((this.pagination.pageNum - 1) * this.pagination.pageSize + index, 1)
                    this.tableData = this.cutArray(this.topicData, this.pagination.pageSize)
                    this.handleChangeTimesCount()
                } else {
                    this.deleteTopicApi(row.topicId)
                }
            },
            openEdit(data){
              this.editRow = data
              this.addVisible = true
            },
            editTopic(data){
              // 已存在的不能修改
              for(let i = 0 ; i<this.topicData.length;i++ ){
                if(this.topicData[i].topicId !== data.topicId && this.topicData[i].topicName == data.name.trim() && this.topicData[i].topicDesc == data.description.trim()){
                  this.$message.error(this.$t('record_is_exist1'))
                  return
                }
              }
              API.pbc.updatePbcAccount({
                groupTopicBindId: data.topicBindId, 
                topicName:data.name, 
                topicDesc: data.description,
                auditType: this.audit,
                entityIdList: this.$refs.tree.getCheckedKeys(),
                groupId: this.activeId,
                periodEndDateTime: dateFormat(new Date(this.ruleForm.endDate), 'yyyy-MM-dd'),
                siteId: this.siteId
              }).then(res => {
                if(res.code == '1'){
                  this.editRow.topicName = data.name
                  this.editRow.topicDesc = data.description
                  this.addVisible = false
                  this.$message({
                    type: 'success',
                    message: this.$t('msg_success')
                  });
                } else {
                  this.$message.error(this.$t(res.code))
                }
              })

            },
            reverseAuth(data){
              this.$confirm(this.$t('PBC_REVERSE_AUTH'), this.$t('REVERSEAUTH_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                iconClass: 'el-icon-warning color-red'
              }).then(() => {
                API.pbc.reverseAccount({topicBindId: data.topicBindId}).then(res => {
                  if(res.code == '1'){
                    this.$message({
                      type: 'success',
                      message: this.$t('msg_success')
                    });
                  } else {
                    this.$message.error(this.$t(res.code))
                  }
                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('CANCLE_OPERATION')
                });
              });
            },
            deleteTopicApi(id) {
                const params = {
                    topicId: id
                }
                API.pbc.deleteTopic(params).then(res => {
                    if (res.code == '1') {
                        this.getPbcList('CURRENT')
                        this.$message.success(this.$t('msg_success'))
                        this.handleChangeTimesCount()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {

                })
            },
            addTopicToList(data) {
                // 已存在的不能添加
                for(let i = 0 ; i<this.topicData.length;i++ ){
                  if(this.topicData[i].topicName == data.name.trim() && this.topicData[i].topicDesc == data.description.trim()){
                    this.$message.error(this.$t('record_is_exist'))
                    return
                  }
                }
                this.topicData.unshift({
                    type: 'NEW',
                    topicName: data.name,
                    topicDesc: data.description,
                    kpmgInCharge: '',
                    clientInCharge: '',
                    dueDateStamp: '',
                    topicSrc: 2,
                    childTopic: [],
                    checked: true
                })
                this.tableData = this.cutArray(this.topicData, this.pagination.pageSize)
                this.addVisible = !this.addVisible
                this.handleChangeTimesCount()
            },
            deletePbc(data, notGetPbcList = false) {
                if (data.type == 'New') {
                    this.pbcList.forEach((item, index) => {
                        if (item.type && item.type == data.type && data.groupId == item.groupId) {
                            this.pbcList.splice(index, 1)
                        }
                    })
                    if (!notGetPbcList) {
                      this.getPbcList('INIT')
                    }
                } else {
                    deleteConfirm().then(() => {
                        API.pbc.deletePbcGroup({
                          groupId: data.groupId,
                          siteId: this.siteId
                        }).then(res => {
                            if (res.code == '1') {
                                this.getPbcList('INIT')
                                this.$message.success(this.$t('msg_success'))

                            } else {
                                this.$message.error(this.$t(res.code))
                            }
                        })
                    })
                }
            },
            toggleAccountVisible(){
                this.accountVisible = !this.accountVisible
            },
          // account文件导入，已存在的不能添加
            uploadAccountSuccess(uploadFileList){
              let uploadTemp = [], addTemp = []
              let len1 = uploadFileList.length, len2 = this.topicData.length
              if(len1 > 0 ){
                for(let i = 0 ; i < len1; i++ ){
                  let notSimple = true
                  let uName = uploadFileList[i].topicName.trim()
                  let uDesc = uploadFileList[i].topicDesc == null? '' : uploadFileList[i].topicDesc.trim()
                  // 上传的文件中topicName不能为空
                  if(uName != null && uName != ''){
                    for(let j = 0 ; j < len2 ; j++){
                      let tName = this.topicData[j].topicName.trim()
                      let tDesc = this.topicData[j].topicDesc == null? '' : this.topicData[j].topicDesc.trim()
                      if(uName == tName && uDesc == tDesc){
                        notSimple = false
                        break
                      }
                    }
                    if(notSimple){
                      uploadTemp.push(uploadFileList[i])
                    }
                  }
                }
              }
              if(uploadTemp.length > 0){
                uploadTemp.forEach(item => {
                  addTemp.push({
                    type: 'NEW',
                    topicName: item.topicName,
                    topicDesc: item.topicDesc,
                    kpmgInCharge: '',
                    clientInCharge: '',
                    dueDateStamp: '',
                    topicSrc: 2,
                    childTopic: [],
                    checked: true
                  })
                })
                this.topicData.unshift(...addTemp)
                this.tableData = this.cutArray(this.topicData, this.pagination.pageSize)
              }
              this.handleChangeTimesCount()
              this.accountVisible = false
            },
            activePbc(data) {
                if (this.activeId == data.groupId) return
                const newList = this.pbcList.filter(item => item.type && item.type === 'New')
                if (this.changeTimesCount > 0) {
                  this.$confirm(this.$t('pbc_change_tips'), this.$t('COMMON_TIP'), {
                      confirmButtonText: this.$t('btn_confirm'),
                      cancelButtonText: this.$t('btn_cancel'),
                      type: 'warning'
                  }).then(() => {
                      // 删除未保存的
                      if (newList.length) {
                        this.deletePbc(newList[0], true)
                      }
                      this.realActive(data)
                  }).catch(() => {});
                } else {
                  if (newList.length) {
                    this.deletePbc(newList[0], true)
                  }
                  this.realActive(data)
                }
            },
            realActive(data) {
                this.editFlag = false
                this.activeId = data.groupId
                if (data.type && data.type == 'New') {
                    this.initPbcDetail('')
                    this.topicDisabled = false
                } else {
                    this.initPbcDetail(this.activeId)
                    this.editFlag = true
                    this.topicDisabled = true
                }
                this.$nextTick(() => {
                  this.$refs.ruleForm.resetFields();
                })
            },
            onConfirm() {
                this.$refs.ruleForm.validate(validate => {
                    if (validate) {
                        this.onAdd(this.ruleForm)
                    }
                })
            },
            handleCheckboxChange() {
              this.changeTimesCount++
            },
            // 内容变化后记录，当切换pbc时提示
            handleChangeTimesCount() {
              this.changeTimesCount++
            },
            handleCheckChange(data) {
              this.handleChangeTimesCount()
            },
            getDetailInfoByType(type) {
                if (type === 'INIT') {
                  if (this.$route.query.id) {
                      this.activeId = this.$route.query.id
                  } else {
                      this.activeId = this.pbcList.length > 0 ? this.pbcList[0].groupId : ''
                  }
                }
                else if (type === 'CURRENT') {}
                else if (type === 'LAST') {
                    const len = this.pbcList.length
                    this.activeId = len > 0 ? this.pbcList[len - 1].groupId : ''
                }
                this.editFlag = this.pbcList.length > 0
                
                if(this.activeId !== ''){
                  this.topicDisabled = true
                } else {
                  this.topicDisabled = false
                }
                this.initPbcDetail(this.activeId)
            },
            _beforeunloadHandler(event) {
              if (this.changeTimesCount) {
                event.preventDefault()
              }
            },
        },
        components: {
          AccountsAdd,
          importAccount
        },
        async mounted() {
            this.audit = this.$route.query.audit
            this.editView = this.$route.query.edit ? this.$route.query.edit : 'Y'
            this.siteId = this.getSite.siteId
            await this.getPbcList('INIT')
            window.addEventListener('beforeunload', this._beforeunloadHandler)
        },
        beforeDestroy() {
          window.removeEventListener('beforeunload', this._beforeunloadHandler)
        },
        beforeRouteLeave (to, from, next) {
          // 判断是否可以离开
          if (this.changeTimesCount) {
            this.$confirm(this.$t('pbc_change_tips'), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning'
            }).then(() => {
              next(true)
            }).catch(() => {
              next(false)
            });
          } else {
            next(true)
          }
        },
    }
</script>
<style scoped>
  .wl-container {
    color: #444;
    height: 100%;
    background: #f0f0f0;
    padding: 10px;
  }

  .pbc-list {
    height: 100%;
    background-color: #fff;
    padding-bottom: 12px;
    border-radius: 10px;
  }

  .pbc-content {
    background-color: #fff;
    padding: 12px 12px;
  }
  .pbc-list .ul {
    margin-top: 10px;
  }

  .pbc-list .title {
    padding: 0 12px;
    height: 43PX;
    line-height: 43PX;
  }

  .pbc-list .title,
  .pbc-content .title {
    font-weight: 700;
    font-style: normal;
    font-size: 14PX;
    color: #696969;
    white-space: nowrap;
    border-bottom: 1px solid #ebebeb;
  }

  .pbc-list .add-pbc {
    border: 1px dashed rgba(228, 228, 228, 1);
    border-radius: 5px;
    text-align: center;
    height: 45px;
    line-height: 45px;
    margin-top: 10px;
    color: #409eff;
    cursor: pointer;
    margin: 12px;
  }
  .pbc-list .el-form {
    height: calc(100% - 65px - 44PX);
  }
  .pbc-list .ul {
    padding: 0 12px;
    height: 100%;
    overflow-y: auto;
  }
  .pbc-list .add-pbc i {
    font-weight: 600;
  }

  .pbc-list .item-header,
  .pbc-list .item-add {
    position: relative;
    list-style-type: none;
    border: 1px solid rgba(228, 228, 228, 1);
    border-radius: 5px;
    height: 45px;
    margin-bottom: 12px;
  }

  .pbc-list .item-add {
    text-align: center;
    font-size: 28px;
    line-height: 40px;
    color: #48ae2c;
    cursor: pointer;
  }

  .pbc-list .item-add:hover {
    background-color: #f0f0f0;
  }

  .pbc-list .item {
    cursor: pointer;
    position: relative;
    list-style-type: none;
    border: 1px solid rgba(228, 228, 228, 1);
    overflow: hidden;
    border-radius: 5px;
    margin-bottom: 12px;
  }

  .pbc-list .item.active .name {
    color: #409eff;
  }

  .pbc-list .item :hover {
    background-color: #f7faff;
    border-color: #aed6ff;
  }

  .pbc-list .active {
    background-color: #f7faff;
    border-color: #aed6ff;
  }

  .pbc-list .item span {
    display: block;
    text-align: left;
    line-height: 40px;
    width: 100%;
    font-weight: 700;
    font-style: normal;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 45px;
    padding-left: 12px;
  }

  .pbc-list .item i {
    font-size: 16px;
    color: #fd349c;
    position: absolute;
    right: 12px;
    top: 12px;
  }

  .item-header {
    height: 30px;
    background-color: #f0f0f0;
  }
  .entity-list-tree-node {
      width: 100%;
      display: flex;
      justify-content: space-between;
  }
  .entity-list-tree-node .extra-area {
      margin-right: 5px;
      color: #409eff;
      align-self: center;
  }
  .entity-list-tree-node .extra-area:hover {
      margin-right: 5px;
      color: #409eff;
  }
  .tree {
    margin-top: 10px;
    height: 250px;
    overflow-y: auto;
    font-size: 13PX;
  }

  .tree ::v-deep .el-tree-node__content > label.el-checkbox {
    margin-right: 8px;
  }

  .from-content {
    padding-top: 30px;
  }

  .icon-set-cls{
    font-size: 14px;
    color: #c2837c;
    cursor: pointer;
    margin-left: 5px;
  }

  .dropdown-btn {
    color: #409eff !important;
    font-size: 14px;
    cursor: pointer;
  }

  .openAll {
    font-size: 14px;
    margin-left: 6px;
    cursor: pointer;
  }

  .openAll:hover {
    color: #409EFF
  }

  .descForTopic {
    position: absolute;
    right: 6px;
    top: 14px;
    font-size: 14px;
    cursor: pointer;
  }

  .descForTopic:hover {
    color: #005eb8
  }
  .import-entity-btn{
    float: right;
    margin-right: 10px;
  }
  .edit-cls{
    width: 70%;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  ::v-deep .el-tabs__item.is-disabled:not(.is-active) {
    color: #C0C4CC !important;
    cursor: not-allowed;
  }

  .pbc-ruleForm ::v-deep .el-form-item__label {
    line-height: 8px;
  }
</style>
<style>
  .color-red{
    color: #fd349c !important;
  }

  .topic-select-all {
    cursor: pointer;
    font-size: 10PX;
    color: #409eff;
    margin-left: 5px;
  }

.__right-box {
  height: 100%;
  background-color: #fff;
  border-radius: 10px;
}

.__right-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-style: normal;
  font-size: 14PX;
  color: #696969;
  white-space: nowrap;
  border-bottom: 1px solid #ebebeb;
  padding: 0 12px;
  height: 43PX;
  line-height: 43PX;
}

.__right-content {
  height: calc(100% - 44PX);
  padding: 12px;
}
.__right-content .__title {
  height: 30px;
  color: #409eff;
}
.__right-content .__title span {
    display: inline-block;
    background: #409eff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 100%;
    text-align: center;
    color: #fff;
    font-size: 13px;
    position: relative;
    bottom: 1px;
    margin-right: 5px;
}
.__right-content .el-row,
.__right-content .el-col {
  height: 100%;
}

.col-inner {
  height: 58%;
}

.topic-table {
  height: 100%;
}

.__right-content .tree-box {
  height: calc(100% - 30px);
  border: 1px solid #e7e7e7;
  border-radius: 6px;
  padding: 12px;
}
.__right-content .filter-text-input {
  height: 30px;
  margin-bottom: 10px;
}
.__right-content .tree-inner {
  height: calc(100% - 40px);
  overflow-y: auto;
}
.pl-12 {
  padding-left: 15px;
}

.table-box {
  height: 100%;
  border: 1px solid #e7e7e7;
  border-radius: 6px;
  padding: 12px 12px 5px 12px;
  overflow: hidden;
}

.custom-account {
  height: calc(42% - 45px);
  border: 1px solid #e7e7e7;
  border-radius: 6px;
  padding: 12px;
  margin-top: 15px;
}
.custom-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  font-weight: 600;
}
</style>
